"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palu-del-fersina": {
    "1c7422c2": [{
      "hkey": "6531f655",
      "slug": "palu-del-fersina",
      "name": "Palù del Fersina",
      "primary": true,
      "skipSearch": false
    }],
    "erdemolo": [{
      "hkey": "6531f655",
      "slug": "palu-del-fersina",
      "name": "Palù del Fersina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7783a07b": [{
      "hkey": "6531f655",
      "slug": "palu-del-fersina",
      "name": "Palù del Fersina",
      "primary": true,
      "skipSearch": false
    }],
    "stefani": [{
      "hkey": "6531f655",
      "slug": "palu-del-fersina",
      "name": "Palù del Fersina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf8b30e5": [{
      "hkey": "6531f655",
      "slug": "palu-del-fersina",
      "name": "Palù del Fersina",
      "primary": true,
      "skipSearch": false
    }],
    "tolleri": [{
      "hkey": "6531f655",
      "slug": "palu-del-fersina",
      "name": "Palù del Fersina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;